"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var DatePickerInternal_1 = require("./DatePickerInternal");
var date_input_field_1 = require("./subcomponents/date_input_field");
exports.datePickerInternalEnforcedProps = {
    fixedHeight: true,
    highlightDates: [],
    // not provided by design
    todayButton: undefined,
    isClearable: false,
    withPortal: false,
    inline: false,
    showMonthDropdown: false,
    showWeekNumbers: false,
    monthsShown: 1,
    peekNextMonth: false,
    selectsEnd: false,
    selectsStart: false,
    startDate: undefined,
    endDate: undefined,
    dropdownMode: 'scroll',
    forceShowMonthNavigation: true,
    // should not be available to user
    tetherConstraints: [
        {
            to: 'window',
            attachment: 'together'
        }
    ],
    showYearDropdown: true,
    scrollableYearDropdown: false,
    popoverAttachment: 'top left',
    popoverTargetAttachment: 'bottom left',
    popoverTargetOffset: '10px 0',
    calendarClassName: undefined,
    locale: 'de-de',
    dateFormat: undefined,
    dateFormatCalendar: 'MMMM yyyy'
};
exports.datePickerPropTypes = {
    defaultDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.object]),
    error: PropTypes.bool,
    excludeDates: PropTypes.array,
    filterDate: PropTypes.func,
    includeDates: PropTypes.array,
    maxDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.object]),
    minDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.object]),
    onChange: PropTypes.func.isRequired,
    onCommit: PropTypes.func,
    valueDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    placeholder: PropTypes.string
};
var DatePickerWithinContext = /** @class */ (function (_super) {
    __extends(DatePickerWithinContext, _super);
    function DatePickerWithinContext(props) {
        var _this = _super.call(this, props) || this;
        _this.internalPropKeys = [
            'autoComplete',
            'autoFocus',
            'autoFormatDate',
            'calendarClassName',
            'customInput',
            // data-component-id for automated ui testing
            'data-component-id',
            'dateFormat',
            'dateFormatCalendar',
            'dropdownMode',
            'endDate',
            'excludeDates',
            'filterDate',
            'fixedHeight',
            'forceShowMonthNavigation',
            'highlightDates',
            'includeDates',
            'inline',
            'isClearable',
            'locale',
            'maxDate',
            'minDate',
            'monthsShown',
            'name',
            'onBlur',
            'onChange',
            'onChangeRaw',
            'onCommit',
            'onFocus',
            'onMonthChange',
            'openToDate',
            'peekNextMonth',
            'placeholderText',
            'popoverAttachment',
            'popoverTargetAttachment',
            'popoverTargetOffset',
            'readOnly',
            'scrollableYearDropdown',
            'selected',
            'selectsEnd',
            'selectsStart',
            'showMonthDropdown',
            'showWeekNumbers',
            'showYearDropdown',
            'startDate',
            'tetherConstraints',
            'title',
            'todayButton',
            'withPortal',
            'children',
            'className',
            'disabled',
            'id',
            'required',
            'tabIndex',
            'theme'
        ];
        _this.externalPropKeys = [
            'defaultDate',
            'error',
            'excludeDates',
            'filterDate',
            'includeDates',
            'maxDate',
            'minDate',
            'onChange',
            'placeholder',
            'valueDate',
            'onCommit'
        ];
        /**
         * Helper method to reverse arguments of arguments of `onChange` method.
         */
        _this.onChangeMapper = function (changedDate, event) {
            var onChange = _this.props.onChange;
            if (typeof onChange !== 'function') {
                return;
            }
            return onChange(event, changedDate);
        };
        _this.id = props.id || props.ergoElements.idGenerator.next();
        return _this;
    }
    DatePickerWithinContext.prototype.render = function () {
        var _this = this;
        var theme = this.props.ergoElements.theme;
        var _a = this.props, defaultDate = _a.defaultDate, error = _a.error, placeholder = _a.placeholder, valueDate = _a.valueDate;
        var propsReducer = function (acc, key) {
            acc[key] = _this.props[key];
            return acc;
        };
        // Typecast here to prevent errors with react-styleguidist.
        var internalPropKeys = this.internalPropKeys;
        // Filter properties that are not part of the public or internal API of the date picker.
        // Those properties have been set by the user and should be added to the outermost root element.
        var userProps = Object.keys(this.props)
            .filter(function (key) { return internalPropKeys.indexOf(key) === -1 && _this.externalPropKeys.indexOf(key) === -1; })
            .reduce(propsReducer, {});
        // Get only those properties that are part of the internal API.
        var internalProps = Object.keys(this.props)
            .filter(function (key) { return internalPropKeys.indexOf(key) > -1; })
            .reduce(propsReducer, {});
        // Overwrite props for DatePickerInternal
        var newInternalProps = __assign(__assign(__assign({}, internalProps), exports.datePickerInternalEnforcedProps), { 
            // autoFormatDate,
            id: this.id, onChange: this.onChangeMapper, openToDate: defaultDate, placeholderText: placeholder, selected: valueDate, customInput: React.createElement(date_input_field_1.DateInputField, { error: error }), theme: theme });
        if (theme === 'ergo-one' || theme === 'dkv') {
            newInternalProps.popoverTargetOffset = '10px -12px';
        }
        return (React.createElement("div", __assign({}, userProps),
            React.createElement(DatePickerInternal_1.DatePickerInternal, __assign({}, newInternalProps))));
    };
    DatePickerWithinContext.propTypes = exports.datePickerPropTypes;
    DatePickerWithinContext.defaultProps = {
        onChange: function () {
            /* empty on purpose */
        },
        onCommit: function () {
            /* empty on purpose */
        },
        error: false,
        excludeDates: undefined,
        filterDate: undefined,
        includeDates: undefined,
        maxDate: undefined,
        minDate: undefined,
        defaultDate: undefined,
        valueDate: undefined,
        placeholder: 'TT.MM.JJJJ',
        ergoElements: undefined
    };
    return DatePickerWithinContext;
}(React.Component));
exports.DatePickerWithinContext = DatePickerWithinContext;
//# sourceMappingURL=DatePickerWithinContext.js.map